import {
  fileTypeByUrl,
  getFileFormat,
} from '@/components/file-thumbnail/utils';
import { FileType } from '@/types/fileViewer';

// 파일명에서 확장자 추출
export const getFileExtension = (fileName: string): string => {
  return fileTypeByUrl(fileName).toLowerCase();
};

// 파일 타입 감지
export const detectFileType = (fileName: string): FileType => {
  const format = getFileFormat(fileTypeByUrl(fileName));

  switch (format) {
    case 'image':
      return 'image';
    case 'pdf':
      return 'pdf';
    case 'word':
      return 'docx';
    case 'powerpoint':
      return 'ppt';
    case 'excel':
      return 'xls';
    default: {
      // 확장자 기반 체크
      const ext = getFileExtension(fileName);
      if (ext === 'csv') {
        return 'csv';
      }
      if (ext === 'md' || ext === 'markdown') {
        return 'markdown';
      }
      if (ext === 'txt') {
        return 'text';
      }
      if (ext === 'html' || ext === 'htm') {
        return 'html';
      }
      return 'unsupported';
    }
  }
};

// 미리보기 지원 여부 확인
export const isPreviewSupported = (fileName: string): boolean => {
  const fileType = detectFileType(fileName);
  return fileType !== 'unsupported';
};

// 파일명과 확장자 분리
export const getFileNameAndExt = (filename: string) => {
  const dotIndex = filename.lastIndexOf('.');
  if (dotIndex === -1) return { name: filename, ext: '' };

  return {
    name: filename.slice(0, dotIndex),
    ext: filename.slice(dotIndex),
  };
};
